import { ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class OrganisationSetting extends ModelBase {

    public organisationSettingId: number = 0;

    @Rules.Required()
    public organisationId: number = 0;

    public attribute: string  = "";
    
    public value: string  = "";

    // Client only properties / methods
    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        // explicitly add rules for required fields
        rules.failWhen(r => r.attribute.trim() === "", "Attribute is required.");
        rules.failWhen(r => r.value.trim() === "", "Value is required.");
    }
}
